// © Microsoft Corporation. All rights reserved.

/**
 * Network err string
 */
export const networkErrorString = "No network";
